import { FetchAPI } from '@renedelangel/helpers';
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSemanalSinID
    seguimientoSiniestroID
    comentario
    avance
    fechaSeguimiento
    personalSeguimiento
`;

export const ADD_SEGUIMIENTOSEMANALSIN = `
mutation addSeguimientoSemanalSin($input: InputAddSeguimientoSemanalSin!){
    addSeguimientoSemanalSin(input: $input){
        ${CAMPOS}
    }
}
`;

export const UPDATE_SEGUIMIENTOSEMANALSIN = `
mutation updateSeguimientoSemanalSin($input: InputUpdateSeguimientoSemanalSin!){
    updateSeguimientoSemanalSin(input: $input){
        ${CAMPOS}
    }
}
`;

export const DELETE_SEGUIMIENTOSEMANALSIN = `
mutation deleteSeguimientoSemanalSin($input: InputDeleteSeguimientoSemanalSin){
    deleteSeguimientoSemanalSin(input: $input)
}
`;

export const addSeguimientoSemanalSin = async (variables, token) => {
    try {
        let { addSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: ADD_SEGUIMIENTOSEMANALSIN
        });
        return addSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
};

export const updateSeguimientoSemanalSin = async (variables, token) => {
    try {
        let { updateSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_SEGUIMIENTOSEMANALSIN
        });
        return updateSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
};

export const deleteSeguimientoSemanalSin = async (input, token) => {
    try {
        let { deleteSeguimientoSemanalSin } = await FetchAPI.graphql({
            token,
            variables: { input },
            url: urlServidor,
            query: DELETE_SEGUIMIENTOSEMANALSIN
        });
        return deleteSeguimientoSemanalSin;
    } catch ({ message }) { throw new Error(message); }
};
